export default "__VITE_ASSET__DN$U_Vhq__"